import { FC } from "react";

import TimestampField from "../../../components/TimestampField";

const ReservationsTime: FC<any> = (props) => {
  const reservation = props.record;

  return <>{reservation && reservation.firstSlotTime ? <TimestampField {...props} /> : null}</>;
};

export default ReservationsTime;
